export const day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

export const dayFilipino = [
  'Lunes',
  'Martes',
  'Miyerkules',
  'Huwebes',
  'Biyernes',
];

export const dayMapping = dayFilipino.reduce((acc, filipinoDay, index) => {
  acc[filipinoDay] = day[index];
  return acc;
}, {});
